import axios from 'axios'

export default {
  isAuthorized: () => {
    return axios.get(process.env.VUE_APP_API_IS_AUTHORIZED)
  }
}
